import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["filename", "preview", "dropzone", "removeFlag"]

  changed(event) {
    var file = event.target.files && event.target.files[0]
    if (!file) return
    // Picking a new file cancels a pending removal
    if (this.hasRemoveFlagTarget) this.removeFlagTarget.value = "0"
    this.filenameTargets.forEach((el) => {
      el.textContent = file.name
      el.classList.remove("hidden")
    })
  }

  remove() {
    if (this.hasRemoveFlagTarget) this.removeFlagTarget.value = "1"
    if (this.hasPreviewTarget) this.previewTarget.classList.add("hidden")
    if (this.hasDropzoneTarget) this.dropzoneTarget.classList.remove("hidden")
  }
}
